import React from 'react';
import { useAccentBgContext } from '../accent-bg-context/accent-bg-context';
import { Typography, TypographyColor } from '../typography/typography';
import { Badge } from '../badge/badge';
import { notNil } from '../../core/helpers/is-nil';
import styles from './form-label.module.scss';

type Props = {
  htmlFor: string;
  children: string;
  disabled?: boolean;
  mandatory?: boolean;
  /**
   * Number of selected items, only to be used in certain contexts (such as combobox for filtering)
   */
  count?: number;
};

export const FormLabel: React.FC<Props> = ({ htmlFor, children, disabled = false, mandatory = false, count }) => {
  const { isAccentBackground } = useAccentBgContext();

  let textColor: TypographyColor = 'black';
  if (isAccentBackground) textColor = 'white';
  if (disabled) textColor = 'anthrazit-50';

  let mandatoryColor: TypographyColor = 'anthrazit-75';
  if (isAccentBackground) mandatoryColor = 'white';
  if (disabled) mandatoryColor = 'anthrazit-50';

  return (
    <label className={styles.root} htmlFor={htmlFor}>
      <Typography color={textColor} tag="span" variant="headline-3">
        {children}
      </Typography>
      {mandatory ? (
        <Typography className={styles.mandatoryIndicator} color={mandatoryColor} tag="span" variant="headline-3">
          *
        </Typography>
      ) : null}
      {notNil(count) && count > 0 ? (
        <span className={styles.badge}>
          <Badge numberToShow={count} />
        </span>
      ) : null}
    </label>
  );
};
